import countries from 'i18n-iso-countries'
import bs from 'i18n-iso-countries/langs/bs.json'
import de from 'i18n-iso-countries/langs/de.json'
import en from 'i18n-iso-countries/langs/en.json'
import sr from 'i18n-iso-countries/langs/sr.json'

countries.registerLocale(en)
countries.registerLocale(de)
countries.registerLocale(bs)
countries.registerLocale(sr)
